const Input = ({
  // label,
  type,
  id,
  placeholder,
  value,
  onValueChange,
  // icon,
}) => {
  return (
    <div className="mt-3">
      <input
        type={type}
        placeholder={placeholder}
        className={`w-full rounded h-[44px] mt-2 pl-3 text-[#161616] font-normal placeholder:font-Lato text-base placeholder:text-[#69708D] border border-solid border-[#DEE2F3]`}
        value={value}
        onChange={(e) => onValueChange(e.target.value)}
      />
    </div>
    // <div>
    // {/* <label className="block mt-5 text-[#9B9B9B]">{label}</label> */}
    // {/* <div className="relative"> */}
    // {/* <div className="absolute right-[5px] top-[10px]">{icon}</div> */}
    // {/* </div> */}
    // </div>
  );
};

export default Input;
